'use client';

import {
  type ReactNode,
  createContext,
  useCallback,
  useContext,
  useState,
} from 'react';

interface BuyCoinsModalContextType {
  isOpen: boolean;
  openBuyCoinsModal: () => void;
  closeBuyCoinsModal: () => void;
}

const BuyCoinsModalContext = createContext<BuyCoinsModalContextType | null>(
  null,
);

export function BuyCoinsModalProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);

  const openBuyCoinsModal = useCallback(() => setIsOpen(true), []);
  const closeBuyCoinsModal = useCallback(() => setIsOpen(false), []);

  return (
    <BuyCoinsModalContext.Provider
      value={{ isOpen, openBuyCoinsModal, closeBuyCoinsModal }}
    >
      {children}
    </BuyCoinsModalContext.Provider>
  );
}

export function useBuyCoinsModal() {
  const context = useContext(BuyCoinsModalContext);
  if (!context) {
    throw new Error(
      'useBuyCoinsModal must be used within BuyCoinsModalProvider',
    );
  }
  return context;
}
